import cx from 'classnames';
import { ElementType, HTMLAttributes, isValidElement, ReactNode } from 'react';
import css from './NoResults.module.scss';

interface INoResultsProps extends HTMLAttributes<HTMLDivElement> {
  icon?: ElementType | ReactNode;
  message?: string;
  title?: string;
}

export const NoResults = ({
  className,
  children,
  icon,
  message = 'Adjust your search or filters',
  title = 'No results',
  ...rest
}: INoResultsProps) => {
  const renderIcon = () => {
    if (!icon) {
      return null;
    } else if (isValidElement(icon)) {
      return icon;
    } else {
      const IconComponent = icon as ElementType;
      return <IconComponent className={css.icon} />;
    }
  };

  return (
    <div className={cx(css.container, className)} {...rest}>
      {renderIcon()}
      {title && <p className={css.title}>{title}</p>}
      {message && <p className={css.message}>{message}</p>}
      {children}
    </div>
  );
};
